import React from "react";
import { EmailInput } from "@arcteryx/components-form";
import { useTranslation } from "react-i18next";

const FsConfirmEmail = ({ id, name, emailFieldName, label, required, register, getValues, errors }) => {
  const { t } = useTranslation("components-formstack");
  return (
    <EmailInput
      id={id}
      name={name}
      required={required}
      label={label || t("Confirm Email Address")}
      register={register}
      errors={errors}
      validation={{
        emailEquals: value => value === getValues()[emailFieldName] || t("Your email addresses do not match."),
      }}
    />
  );
};

export default FsConfirmEmail;
